import type { FaireProductEntity } from "../../entity_types/product";

export const p_d7cg8rzxnf: FaireProductEntity = {
  token: "p_d7cg8rzxnf",
  type: "product",
  name: "PATCH Eco First-Aid Kit",
  brandToken: "b_1rxnwwatsq",
  brandName: "PATCH - Eco First Aid",
  imageUrl:
    "https://cdn.faire.com/fastly/ee488679f2b19d628fabe01b9ea92d500caa42bfa289e8d91c68d7e825688dd2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35ab6a642adfb9f75062ea8441c61493286b2715cb440b311ae7366b6b111359.png",
    "https://cdn.faire.com/fastly/5fae1e47fcbeecd88f72ccbd64aafdbdf2dc45f47bd6a6c04786d621597dc71b.png",
  ],
  priceDollars: 11.96,
  description:
    "The original Eco First Aid Kit!\n\nContains 78 pieces (3 Units per case):\n15 x PATCH Aloe Vera Bandage Strips \n15 x PATCH Panda Bandage Strips \n4 x PATCH Aloe Large Rectangle Bandages\n4 x PATCH Panda Large Square Bandages\n5 x PATCH Natural Dot Bandages \n1 x PATCH Cohesive Wrap Bandage \n30 x Bamboo Cleaning Buds \n1 x PATCH Black Tweezers \n1 x PATCH Black Scissors \n1 x PATCH Safety Pouch \n1 x PATCH Refillable First-Aid Kit Tin \n",
  tags: [],
  msrpDollars: 20.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:43.113Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
